import React, { useEffect, useRef, useState } from 'react';
import { css } from '@emotion/core';

import Montage from 'ugc/components/ugcGallery/montage/Montage';
import ButtonViewMore from 'ugc/components/ugcGallery/montage/ButtonViewMore';

import Loading from 'client/components/Loading';

export default function MontageContainer({
    config,
    clientBodyRef,
    montageComponentRef,
    buttonLink,
    editor = false
}) {
    const { isShowButton, maskColor } = config.buttonSettings;
    const { isShowWorkInformation } = config.versionStyleSettings;

    const divRef = useRef(null);

    const [ready, setReady] = useState(false);
    const [absoluteStyle, setAbsoluteStyle] = useState(false);

    useEffect(() => {
        const toCountHeight = () => {
            const height = divRef.current.offsetHeight;
            if (height === 0) {
                setReady(false);
            }
            const buttonHeight = 168;
            const divTotalHeight = 880;

            if (height + buttonHeight > divTotalHeight) {
                setAbsoluteStyle(true);
            } else {
                setAbsoluteStyle(false);
            }
        };
        if (ready === true) {
            toCountHeight();
        }
        window.addEventListener('resize', toCountHeight);
        return () => {
            window.removeEventListener('resize', toCountHeight);
        };
    }, [ready]);

    return (
        <>
            {!ready && !editor && <Loading />}
            <div ref={clientBodyRef} css={containerStyle(editor, ready)}>
                <div ref={divRef}>
                    <Montage
                        ref={montageComponentRef}
                        editor={editor}
                        isShowWorkInformation={isShowWorkInformation}
                        setReady={setReady}
                    />
                </div>
                <div
                    css={[
                        buttonContainerStyle(maskColor),
                        (absoluteStyle || editor) && buttonDivAbsolute
                    ]}
                >
                    {isShowButton && (
                        <a href={buttonLink} target="_blank" rel="noreferrer">
                            <ButtonViewMore config={config.buttonSettings} />
                        </a>
                    )}
                </div>
            </div>
        </>
    );
}

const containerStyle = (editor, ready) => css`
    overflow: hidden;
    position: relative;
    max-height: 880px;
    ${editor && `height: 100%;`};
    ${!editor && `padding: 16px 0 0 0 ;`};
    ${!ready && `opacity:0;`}
    & .react-photo-album--column {
        align-items: center !important;
    }
`;

const buttonContainerStyle = maskColor => css`
    max-height: 168px;
    height: 100%;
    z-index: 2;
    background: linear-gradient(0deg, ${maskColor} 28.27%, rgba(250, 255, 0, 0) 94.35%);
    display: flex;
    justify-content: center;
    align-items: center;
`;

const buttonDivAbsolute = css`
    position: absolute;
    left: 0;
    right: 0;
    bottom: -8px;
    margin: auto;
`;
